<template>
  <div class="journal-v">
    <div class="cont">
      <ComTitle
        :show-more="true"
        titleEn="JOURNAL INTRODUCTION"
        titleZh="统计学会期刊介绍"
        zhColor="#333333"
        @more="more"
      ></ComTitle>
      <JournalCover></JournalCover>
    </div>
  </div>
</template>

<script>
import ComTitle from "@/components/common/comTitle";
import JournalCover from "@/components/index/JournalCover";

export default {
  name: "NewsCon",
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  data() {
    return {
      companyNewsList: [],
      companyTotal: 1, // 总数
      companyPageNo: 1, // 当前页
      companyPageSize: 3, // 每页显示条数
    };
  },
  created() {},
  methods: {
    //移除html标签
    removeHTMLTag(str) {
      str = str.replace(/(\n)/g, "");
      str = str.replace(/(\t)/g, "");
      str = str.replace(/(\r)/g, "");
      str = str.replace(/<[^>]+>|&[^>]+;/g, "");
      str = str.replace(/\s*/g, "");
      return str;
    },
    more() {
      this.$router.push({ name: "journal" });
    },
  },
  components: { ComTitle, JournalCover },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
.journal-v {
  width: 100%;
  min-width: 1180px;
  overflow: hidden;

  .cont {
    width: 1180px;
    margin: 0 auto;
  }
}
</style>
